import React, { useEffect, useState } from "react";
import moment from "moment";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import { post } from "../js/post";
import { formatValueUnit, selectedOptic, userData } from "../js/utils";
import "../css/SalesManagement.css";

import { prepareOrder } from "../support-extra/js/prepareOrder";

export default function SalesManagement({
  id,
  patientInfo,
  category,
  createPopupQuestion,
  removePopupQuestion,
  products,
  onClose,
  onCloseCard,
  onClickMenuOption,
}) {
  const [data, setData] = useState({
    prod1: {},
    prod2: {},
    prod3: {},
    extras: [],
  });
  const [fullData, setFullData] = useState(false);
  const [workOrder, setWorkOrder] = useState(true);
  const [total, setTotal] = useState(0);
  const [orderProd, setOrderProd] = useState({
    prod1: false,
    prod2: false,
    prod3: false,
  });
  const [processing, setProcessing] = useState(false);

  function calculateTotal() {
    const pvpMontura = data.prod1?.totalPrecio || 0;
    const pvpLenteOD = data.prod2?.totalPrecio || 0;
    const pvpLenteOI = data.prod3?.totalPrecio || 0;
    const pvpExtras =
      data.extras?.reduce((sum, extra) => sum + (extra.total || 0), 0) || 0;

    const total = pvpMontura + pvpLenteOD + pvpLenteOI + pvpExtras;

    setTotal(total.toFixed(2));
  }

  function refineStructure() {
    const newData = {
      prod1: products.prod1 || {},
      prod2: products.prod2 || {},
      prod3: products.prod3 || {},
      extras: products.extras || [],
    };
    setData(newData);
  }

  function handleDeleteProduct(type, id = null) {
    setData((prevData) => {
      if (type === "extras" && id !== null) {
        return {
          ...prevData,
          extras: prevData.extras.filter((extra) => extra.id !== id),
        };
      } else {
        return {
          ...prevData,
          [type]: {},
        };
      }
    });
    setOrderProd((prevData) => ({
      ...prevData,
      [type]: false,
    }));
  }

  function getLabel(pos) {
    const labels = {
      gafas: ["Montura", "Lente derecha", "Lente izquierda"],
      LC: ["LC derecha", "LC izquierda", "Líquido"],
      audifonos: ["Audífono derecho", "Audífono izquierdo", "Cargador"],
    };

    return labels[category]?.[pos] || "";
  }

  function showData(pos) {
    const categoryFields = {
      gafas: ["marca", "modelo", "nombreComercial", "color"],
      LC: ["marca", "nombreComercial", "color"],
      audifonos: ["marca", "modelo"],
    };

    const fields = categoryFields[category] || [];
    const product = data[`prod${pos + 1}`];

    return product
      ? fields
          .map((field) => product[field])
          .filter(Boolean)
          .join(" ")
      : "";
  }

  function getIcon(pos) {
    const labels = {
      gafas: ["menu-gafas-blue.svg", "lente-blue.svg", "lente-blue.svg"],
      LC: [
        "menu-lentillas-blue.svg",
        "menu-lentillas-blue.svg",
        "liquido-blue.svg",
      ],
      audifonos: ["audifono-blue.svg", "audifono-blue.svg", "bateria-blue.svg"],
    };

    return labels[category]?.[pos] || "";
  }

  async function addToShoppingCart() {
    const response = await post("support-extra/cesta/AnadirACesta.php", {
      token: userData.token,
      idPaciente: patientInfo.id,
      idFicha: id,
      idOptica: selectedOptic.id,
      imprimirFicha: fullData,
      imprimirOrden: workOrder,
      total: total,
      prod1:
        Object.keys(data.prod1).length > 0
          ? {
              codigo: data.prod1.codigo,
              pedirProducto: orderProd.prod1,
            }
          : {},
      prod2:
        Object.keys(data.prod2).length > 0
          ? {
              codigo: data.prod2.codigo,
              pedirProducto: orderProd.prod2,
            }
          : {},
      prod3:
        Object.keys(data.prod3).length > 0
          ? {
              codigo: data.prod3.codigo,
              pedirProducto: orderProd.prod3,
            }
          : {},
      extras: data.extras.map((extra) => {
        return extra.id;
      }),
    });
    // console.log(
    // "AÑADIENDO A CESTA: ",
    // {
    // token: userData.token,
    // idPaciente: patientInfo.id,
    // idFicha: id,
    // idOptica: selectedOptic.id,
    // imprimirFicha: fullData,
    // imprimirOrden: workOrder,
    // total: total,
    // prod1:
    // Object.keys(data.prod1).length > 0
    // ? {
    // codigo: data.prod1.codigo,
    // pedirProducto: orderProd.prod1,
    // }
    // : {},
    // prod2:
    // Object.keys(data.prod2).length > 0
    // ? {
    // codigo: data.prod2.codigo,
    // pedirProducto: orderProd.prod2,
    // }
    // : {},
    // prod3:
    // Object.keys(data.prod3).length > 0
    // ? {
    // codigo: data.prod3.codigo,
    // pedirProducto: orderProd.prod3,
    // }
    // : {},
    // extras: data.extras.map((extra) => {
    // return extra.id;
    // }),
    // },
    // response,
    // );

    if (response.error !== "") {
      createPopupQuestion(
        response.error,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    } else {
      createPopupQuestion(
        `La ficha se ha añadido a la cesta correctamente.`,
        () => {
          removePopupQuestion();
        },
        null,
        "Entendido",
      );
    }
  }

  const onClickVenta = () => {
    const order = prepareOrder(data, id, patientInfo.id, category);
    if (products.sol) {
      order.category = "SOL";
    }
    order.campaign = products.motivo || "";
    onClickMenuOption("venta", {
      saleId: -1,
      orderCards: [order],
      orderPatientId: patientInfo.id,
    });
    onClose();
    onCloseCard();
  };

  const onClickEncargo = () => {
    const order = prepareOrder(data, id, patientInfo.id, category);
    if (products.sol) {
      order.category = "SOL";
    }
    order.campaign = products.motivo || "";
    onClickMenuOption("encargo", {
      saleId: -1,
      orderCards: [order],
      orderPatientId: patientInfo.id,
    });
    onClose();
    onCloseCard();
  };

  const onClickPresupuesto = () => {
    const order = prepareOrder(data, id, patientInfo.id, category);
    if (products.sol) {
      order.category = "SOL";
    }
    order.campaign = products.motivo || "";
    onClickMenuOption("presupuesto", {
      saleId: -1,
      orderCards: [order],
      orderPatientId: patientInfo.id,
    });
    onClose();
    onCloseCard();
  };

  const onClickProforma = () => {
    const order = prepareOrder(data, id, patientInfo.id, category);
    if (products.sol) {
      order.category = "SOL";
    }
    order.campaign = products.motivo || "";
    onClickMenuOption("proforma", {
      saleId: -1,
      orderCards: [order],
      orderPatientId: patientInfo.id,
    });
    onClose();
    onCloseCard();
  };

  function buildLensOrderPayload(lens, ojo) {
    return {
      token: userData.token,
      idPedido: -1,
      idOptica: selectedOptic.id,
      codigo: lens.codigo,
      proveedor: lens.idProveedor,
      marca: lens.marca,
      nombreComercial: lens.nombreComercial,
      tipo: lens.tipo,
      color: lens.color,
      material: lens.material,
      ojo,
      tratamiento: lens.tratamiento,
      refProveedor: lens.refProveedor || "",
      ind: lens.ind,
      esf: lens.esf,
      cil: lens.cil,
      eje: lens.eje,
      add: lens.add,
      total: lens.total,
      dia: lens.dia,
      den: lens.den || "",
      abbe: lens.abbe || "",
      fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
      fechaRecepcion: "",
      estado: "Pendiente",
      unidades: 1,
      pedidoAutomatizado: "",
      idPedidoAutomatizado: "",
      urlPedidoAutomatizado: "",
      idFicha: id,
      idPaciente: patientInfo.id,
    };
  }

  function buildSunGlassesLensOrderPayload(lens, montura) {
    return {
      token: userData.token,
      idPedido: -1,
      idOptica: selectedOptic.id,
      codigo: lens.codigo,
      proveedor: lens.idProveedor,
      marca: lens.marca,
      modelo: montura.modelo,
      genero: montura.genero,
      color: lens.color,
      calibre: montura.calibre1,
      puente: montura.calibre2,
      colorCristal: montura.colorCristal,
      material: lens.material,
      varilla: montura.varilla,
      forma: montura.forma,
      refProveedor: lens.refProveedor || "",
      fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
      fechaRecepcion: "",
      estado: "Pendiente",
      unidades: 1,
      idFicha: id,
      idPaciente: patientInfo.id,
    };
  }

  async function processGlassesOrders() {
    await post("support-extra/pedidos/EliminarPedidoFichaGafas.php", {
      token: userData.token,
      idFicha: id,
    });

    if (Object.keys(data.prod1).length > 0 && orderProd.prod1) {
      await post("support-extra/pedidos/GuardarPedidoMontura.php", {
        token: userData.token,
        idPedido: -1,
        idOptica: selectedOptic.id,
        codigo: data.prod1.codigo,
        proveedor: data.prod1.idProveedor,
        marca: data.prod1.marca,
        modelo: data.prod1.modelo,
        genero: data.prod1.genero,
        color: data.prod1.color,
        calibre: data.prod1.calibre1,
        puente: data.prod1.calibre2,
        material: data.prod1.material,
        varilla: data.prod1.varilla,
        forma: data.prod1.forma,
        refProveedor: data.prod1.refProveedor,
        fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
        fechaRecepcion: "",
        estado: "Pendiente",
        unidades: 1,
        idFicha: id,
        idPaciente: patientInfo.id,
      });
    }

    if (Object.keys(data.prod2).length > 0 && orderProd.prod2) {
      if (products.sol) {
        await post(
          "support-extra/pedidos/GuardarPedidoGafasSol.php",
          buildSunGlassesLensOrderPayload(data.prod2, data.prod1),
        );
      } else {
        await post(
          "support-extra/pedidos/GuardarPedidoLenteOftalmica.php",
          buildLensOrderPayload(data.prod2, 0),
        );
        // console.log("GUARDANDO PEDIDO: ", buildLensOrderPayload(data.prod2, 0));
      }
    }

    if (Object.keys(data.prod3).length > 0 && orderProd.prod3) {
      if (products.sol) {
        await post(
          "support-extra/pedidos/GuardarPedidoGafasSol.php",
          buildSunGlassesLensOrderPayload(data.prod3, data.prod1),
        );
      } else {
        await post(
          "support-extra/pedidos/GuardarPedidoLenteOftalmica.php",
          buildLensOrderPayload(data.prod3, 1),
        );
        // console.log("GUARDANDO PEDIDO: ", buildLensOrderPayload(data.prod3, 1));
      }
    }
  }

  function buildContactLensOrderPayload(lens) {
    return {
      token: userData.token,
      idPedido: -1,
      idOptica: selectedOptic.id,
      codigo: lens.codigo,
      proveedor: lens.idProveedor,
      marca: lens.marca,
      nombreComercial: lens.nombreComercial,
      tipo: lens.tipo,
      color: lens.color,
      desechable: lens.desechable,
      unidadesCaja: lens.unidades,
      uso: lens.uso,
      refProveedor: lens.refProveedor || "",
      esf: lens.esf,
      cil: lens.cil,
      eje: lens.eje,
      add: lens.add,
      total: lens.total,
      rad1: lens.rad,
      rad2: lens.rad2,
      dia: lens.dia,
      hid: lens.hid || "",
      zo: lens.zo || "",
      ela: lens.ela || "",
      fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
      fechaRecepcion: "",
      estado: "Pendiente",
      unidades: 1,
      idFicha: id,
      idPaciente: patientInfo.id,
    };
  }

  function buildLiquidOrderPayload(liquido) {
    return {
      token: userData.token,
      idPedido: -1,
      idOptica: selectedOptic.id,
      codigo: liquido.codigo,
      proveedor: liquido.idProveedor,
      marca: liquido.marca,
      nombreComercial: liquido.nombreComercial,
      capacidad: liquido.capacidad,
      refProveedor: liquido.refProveedor || "",
      fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
      fechaRecepcion: "",
      estado: "Pendiente",
      unidades: 1,
      idFicha: id,
      idPaciente: patientInfo.id,
    };
  }

  async function processContactLensesOrders() {
    await post("support-extra/pedidos/EliminarPedidoFichaLentesContacto.php", {
      token: userData.token,
      idFicha: id,
    });

    if (Object.keys(data.prod1).length > 0 && orderProd.prod1) {
      await post(
        "support-extra/pedidos/GuardarPedidoLenteContacto.php",
        buildContactLensOrderPayload(data.prod1),
      );
    }

    if (Object.keys(data.prod2).length > 0 && orderProd.prod2) {
      await post(
        "support-extra/pedidos/GuardarPedidoLenteContacto.php",
        buildContactLensOrderPayload(data.prod2),
      );
    }

    if (Object.keys(data.prod3).length > 0 && orderProd.prod3) {
      await post(
        "support-extra/pedidos/GuardarPedidoLiquido.php",
        buildLiquidOrderPayload(data.prod3),
      );
    }
  }

  function buildHearingAidOrderPayload(hearingAid) {
    return {
      token: userData.token,
      idPedido: -1,
      idOptica: selectedOptic.id,
      codigo: hearingAid.codigo,
      proveedor: hearingAid.idProveedor,
      marca: hearingAid.marca,
      modelo: hearingAid.modelo,
      tipo: hearingAid.tipo,
      entreDB: hearingAid.entreDb,
      hastaDB: hearingAid.hastaDb,
      nSerie: hearingAid.nSerie,
      refProveedor: hearingAid.refProveedor || "",
      fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
      fechaRecepcion: "",
      estado: "Pendiente",
      unidades: 1,
      idFicha: id,
      idPaciente: patientInfo.id,
    };
  }

  function buildChargerOrderPayload(charger) {
    return {
      token: userData.token,
      idPedido: -1,
      idOptica: selectedOptic.id,
      codigo: charger.codigo,
      proveedor: charger.idProveedor,
      marca: charger.marca,
      producto: charger.modelo,
      subtipo: charger.subtipo || "",
      refProveedor: charger.refProveedor || "",
      fechaPedido: moment().format("YYYY-MM-DD HH:mm:ss"),
      fechaRecepcion: "",
      estado: "Pendiente",
      unidades: 1,
      idFicha: id,
      idPaciente: patientInfo.id,
    };
  }

  async function processHearingAidsOrders() {
    await post("support-extra/pedidos/EliminarPedidoFichaAudifonos.php", {
      token: userData.token,
      idFicha: id,
    });

    if (Object.keys(data.prod1).length > 0 && orderProd.prod1) {
      await post(
        "support-extra/pedidos/GuardarPedidoAudifono.php",
        buildHearingAidOrderPayload(data.prod1),
      );
    }

    if (Object.keys(data.prod2).length > 0 && orderProd.prod2) {
      await post(
        "support-extra/pedidos/GuardarPedidoAudifono.php",
        buildHearingAidOrderPayload(data.prod2),
      );
    }

    if (Object.keys(data.prod3).length > 0 && orderProd.prod3) {
      await post(
        "support-extra/pedidos/GuardarPedidoVarios.php",
        buildChargerOrderPayload(data.prod3),
      );
    }
  }

  async function runAction(action) {
    setProcessing(true);
    try {
      if (category === "gafas") {
        await processGlassesOrders();
      } else if (category === "LC") {
        await processContactLensesOrders();
      } else if (category === "audifonos") {
        await processHearingAidsOrders();
      }
      await action();
    } finally {
      setProcessing(false);
    }
  }

  useEffect(() => {
    refineStructure();
  }, []);

  useEffect(() => {
    calculateTotal();
  }, [data]);

  return (
    <div className="sm-container container-panel">
      <div className="opt-table-content grid-9" id="sales-content-grid">
        <div className="cell opt-table-title cell-start-content combined-cells-3">
          Productos seleccionados
        </div>
        <div className="cell"></div>
        <div className="cell opt-table-title cell-start-content combined-cells-2">
          Pasar a cartera de pedidos
        </div>
        <div className="cell"></div>
        <div className="cell opt-table-title cell-start-content combined-cells-2">
          Impresión de documentos
        </div>
        {Object.keys(data.prod1).length > 0 && <></>}
        <div className="cell opt-table-subtitle cell-start-content">
          <img
            src={`/images/${getIcon(0)}`}
            className="icon-pref"
            alt="Icono"
          ></img>
          <span className="cell-label">{getLabel(0)}</span>
          {Object.keys(data.prod1).length > 0 ? showData(0) : "Eliminada"}
        </div>
        <div className="cell cell-end-content opt-table-subtitle">
          {formatValueUnit(Number(data.prod1?.totalPrecio) || 0, "€")}
        </div>
        <div className="cell">
          {Object.keys(data.prod1).length > 0 && (
            <img
              src={`/images/remove-blue.svg`}
              className="icon-pref"
              alt="Eliminar producto"
              onClick={() => {
                createPopupQuestion(
                  `¿Desea eliminar el producto?`,
                  async () => {
                    handleDeleteProduct("prod1");
                    removePopupQuestion();
                  },
                  removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            ></img>
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Pedir producto</div>
        <div className="cell">
          <div
            className={
              Object.keys(data.prod1).length > 0
                ? "data-field c-pointer"
                : "data-field"
            }
            onClick={() => {
              if (Object.keys(data.prod1).length === 0) return;
              setOrderProd((prev) => ({
                ...prev,
                prod1: !prev.prod1,
              }));
            }}
          >
            <CheckBox
              tabIndex={130}
              active={orderProd.prod1}
              disabled={Object.keys(data.prod1).length === 0}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Ficha completa</div>
        <div className="cell">
          <div
            className="data-field c-pointer"
            onClick={() => {
              setFullData(!fullData);
            }}
          >
            <CheckBox
              tabIndex={130}
              active={fullData}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
        <div className="cell opt-table-subtitle cell-start-content">
          <img
            src={`/images/${getIcon(1)}`}
            className="icon-pref"
            alt="Icono"
          ></img>
          <span className="cell-label">{getLabel(1)}</span>
          {Object.keys(data.prod2).length > 0 ? showData(1) : "Eliminada"}
        </div>
        <div className="cell cell-end-content opt-table-subtitle">
          {formatValueUnit(Number(data.prod2?.totalPrecio) || 0, "€")}
        </div>
        <div className="cell">
          {Object.keys(data.prod2).length > 0 && (
            <img
              src={`/images/remove-blue.svg`}
              className="icon-pref"
              alt="Eliminar producto"
              onClick={() => {
                createPopupQuestion(
                  `¿Desea eliminar el producto?`,
                  async () => {
                    handleDeleteProduct("prod2");
                    removePopupQuestion();
                  },
                  removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            ></img>
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Pedir producto</div>
        <div className="cell">
          <div
            className={
              Object.keys(data.prod2).length > 0
                ? "data-field c-pointer"
                : "data-field"
            }
            onClick={() => {
              if (Object.keys(data.prod2).length === 0) return;
              setOrderProd((prev) => ({
                ...prev,
                prod2: !prev.prod2,
              }));
            }}
          >
            <CheckBox
              tabIndex={130}
              active={orderProd.prod2}
              disabled={Object.keys(data.prod2).length === 0}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">
          Orden de trabajo
        </div>
        <div className="cell">
          <div
            className="data-field c-pointer"
            onClick={() => {
              setWorkOrder(!workOrder);
            }}
          >
            <CheckBox
              tabIndex={130}
              active={workOrder}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
        <div className="cell opt-table-subtitle cell-start-content">
          <img
            src={`/images/${getIcon(2)}`}
            className="icon-pref"
            alt="Icono"
          ></img>
          <span className="cell-label">{getLabel(2)}</span>
          {Object.keys(data.prod3).length > 0 ? showData(2) : "Eliminada"}
        </div>
        <div className="cell cell-end-content opt-table-subtitle">
          {formatValueUnit(Number(data.prod3?.totalPrecio) || 0, "€")}
        </div>
        <div className="cell">
          {Object.keys(data.prod3).length > 0 && (
            <img
              src={`/images/remove-blue.svg`}
              className="icon-pref"
              alt="Eliminar producto"
              onClick={() => {
                createPopupQuestion(
                  `¿Desea eliminar el producto?`,
                  async () => {
                    handleDeleteProduct("prod3");
                    removePopupQuestion();
                  },
                  removePopupQuestion,
                  "Sí",
                  "No",
                );
              }}
            ></img>
          )}
        </div>
        <div className="cell"></div>
        <div className="cell cell-label cell-start-content">Pedir producto</div>
        <div className="cell">
          <div
            className={
              Object.keys(data.prod3).length > 0
                ? "data-field c-pointer"
                : "data-field"
            }
            onClick={() => {
              if (Object.keys(data.prod3).length === 0) return;
              setOrderProd((prev) => ({
                ...prev,
                prod3: !prev.prod3,
              }));
            }}
          >
            <CheckBox
              tabIndex={130}
              active={orderProd.prod3}
              disabled={Object.keys(data.prod3).length === 0}
              onClick={() => {}}
            ></CheckBox>
          </div>
        </div>
        <div className="cell"></div>
        <div className="cell combined-cells-2"></div>
        {data.extras.map((e, i) => {
          return (
            <React.Fragment key={i}>
              <div className="cell opt-table-subtitle cell-start-content">
                <img
                  src={`/images/extra-blue.svg`}
                  className="icon-pref"
                  alt="Icono"
                ></img>
                <span className="cell-label">Extra</span>
                {`${e.descripcion}`}
              </div>
              <div className="cell cell-end-content opt-table-subtitle">
                {formatValueUnit(e.total, "€")}
              </div>
              <div className="cell">
                <img
                  src={`/images/remove-blue.svg`}
                  className="icon-pref"
                  alt="Eliminar producto"
                  onClick={() => {
                    createPopupQuestion(
                      `¿Desea eliminar el producto?`,
                      async () => {
                        handleDeleteProduct("extras", e.id);
                        removePopupQuestion();
                      },
                      removePopupQuestion,
                      "Sí",
                      "No",
                    );
                  }}
                ></img>
              </div>
              <div className="cell"></div>
              <div className="cell combined-cells-5"></div>
            </React.Fragment>
          );
        })}
        <div className="cell cell-label cell-end-content">TOTAL: </div>
        <div className="cell opt-table-subtitle cell-end-content">
          {formatValueUnit(total, "€")}
        </div>
        <div className="cell combined-cells-7"></div>
      </div>
      <div className="popup-buttons">
        <ButtonIconH
          text="Añadir a cesta"
          disabled={processing}
          onClick={() => runAction(addToShoppingCart)}
        ></ButtonIconH>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: 10,
          }}
        >
          <ButtonIconH
            text="Venta"
            disabled={processing}
            onClick={() => runAction(onClickVenta)}
          ></ButtonIconH>
          <ButtonIconH
            text="Encargo"
            disabled={processing}
            onClick={() => runAction(onClickEncargo)}
          ></ButtonIconH>
          <ButtonIconH
            text="Presupuesto"
            disabled={processing}
            onClick={() => runAction(onClickPresupuesto)}
          ></ButtonIconH>
          <ButtonIconH
            text="Proforma"
            disabled={processing}
            onClick={() => runAction(onClickProforma)}
          ></ButtonIconH>
        </div>
        <ButtonIconH
          text="Volver"
          disabled={processing}
          onClick={onClose}
        ></ButtonIconH>
      </div>
    </div>
  );
}
